// The full years from `eventTime` to `asOfTime`, counted by anniversaries,
// and 0 for an event after `asOfTime`.
export const fullYearsBetween = (eventTime: number, asOfTime: number) => {
  const event = new Date(eventTime)
  let fullYears = new Date(asOfTime).getUTCFullYear() - event.getUTCFullYear()
  const anniversary = new Date(eventTime)
  anniversary.setUTCFullYear(event.getUTCFullYear() + fullYears)
  if (anniversary.getTime() > asOfTime) fullYears--
  return Math.max(0, fullYears)
}

// ADR-0129 (straight-line aging): a Detection, an adverse ceiling and a
// customer report age the same way, each at its own rate (ADR-0147). Its
// weight falls by `annualDecay` of its initial weight on each full year of
// age at `asOf`, counted by anniversaries, until nothing is left: at 0.1 a
// record weighs 1, 0.9, 0.8 … 0.1 and nothing from its tenth anniversary. A
// record dated after `asOf` weighs in full.
export const agedWeight = (
  eventTime: number,
  asOfTime: number,
  annualDecay: number
) => Math.max(0, 1 - annualDecay * fullYearsBetween(eventTime, asOfTime))

// The calendar day `years` before `asOf`. The registry standing rules read no
// episode older than their lookback (ADR-0129).
export const dayYearsBefore = (asOfTime: number, years: number) => {
  const asOf = new Date(asOfTime)
  return new Date(
    Date.UTC(
      asOf.getUTCFullYear() - years,
      asOf.getUTCMonth(),
      asOf.getUTCDate()
    )
  )
    .toISOString()
    .slice(0, 10)
}
